import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback
} from "react";

import axiosInstance from "../../../utils/axiosInstance";
import { utils, writeFile } from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useReactToPrint } from "react-to-print";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../store/loaderSlice";

import { useParams } from "react-router-dom";
import DatePickerComponent from "../../client/components/DatePickerComponent";
import Bootstrap4DatePickerComponent from "../../client/components/Bootstrap4DatePickerComponent";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css"; // Buttons extension styling
import "./TableComponent.css"; // Import your CSS file

import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";

import JSZip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

//import "datatables.net-dt/css/dataTables.dataTables.css";
//import "datatables.net-buttons-dt/css/buttons.dataTables.css";
 

import { isMobile } from "react-device-detect";

export default function PlDownlinePopup() {
  const { userId } = useParams();
  const { type } = useParams();
  const dispatch = useDispatch();

  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);

  const [uniqueGridKey, setUniqueGridKey] = useState(Date.now());
  const [isLoading, setIsLoading] = useState(true);
  const [statement, setStatement] = useState([]);
  const [dataUserName, setDataUserName] = useState("");

  const [pageSize, setPageSize] = useState(100);

  const loadingRef = useRef(false);
  const gridTableRef = useRef(null);
  const defaultExpand = true;

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  function escapeHtml(str = "") {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  const showDescription = (data, row) => {
    let marketTypeTxt = "";
    if (row.market_type == 2) {
      marketTypeTxt = "/Bookmaker";
    } else if (row.market_type == 1) {
      marketTypeTxt = "/Match Odd";
    } else if (row.market_type == 5) {
      marketTypeTxt = "/Tie";
    } else if (row.market_type == 6) {
      marketTypeTxt = "/Figure";
    } else if (row.market_type == 8) {
      marketTypeTxt = "/EvenOdd";
    } else if (row.market_type == 3) {
      marketTypeTxt = "/Fancy";
    }

    data = escapeHtml(String(data ?? ""));

    if (data === "Opening Balance") {
      return `<span style='color:#04b181;font-weight:semibold;'  className="site_family">${data}</span>`;
    }

    const resultTxt = row.result ? ` [${row.result}]` : "";
    //const label = `${row.remark}`;
    const label = `${row.description}${marketTypeTxt}${resultTxt}`;

    if (Number(row.voided) === 1) {
      return `<a href="#" onClick="showBetDetails('${row.id}',${row.game_type},${row.market_type})" class="text-muted ledger-row-voided site_family">
      ${label} (VOID)</a>`;
    }

    return `<a href="#" style="font-size:1rem;color:#04b181;" onClick="showBetDetails('${row.id}',${row.game_type},${row.market_type})" class="site_family">
      ${label}</a>`;
  };

  const cols = useMemo(
    () => [
      {
        title: "#",
        data: "seq",
        orderable: true,
        className: "dt-center",
        responsivePriority: 1,
        render: (data, type, row, meta) => {
          if (type === "display" || type === "filter") {
            return `
              <div class="seq-cell">
              <button type="button" class="toggle-row toggle-closed">+</button>
                <span class="seq-number"  style="padding-left:10px">${data}</span>
                
              </div>
            `;
          }
          return data;
        }
      },
      {
        title: "Date",
        data: "created_date",
        className: "dt-right",
        // After Description so on narrow screens # + Date + Description stay visible; Amount/Balance move to expanded details
        responsivePriority: 2,
        render: (d, type) => {
          if (type === "display" || type === "filter") {
            if (!d) return "";
            const dt = new Date(d);
            const datePart = dt.toLocaleDateString(undefined, {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            });
            const fullTime = dt.toLocaleTimeString(undefined, {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true
            });
            // Split "04:47 pm" into time "04:47" and meridiem "pm"
            const meridiemMatch = fullTime.match(/^([\d:]+)\s*(am|pm)$/i);
            if (meridiemMatch) {
              const hhmm = meridiemMatch[1];
              const meridiem = meridiemMatch[2];
              return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:1rem">${hhmm}</span> <span class="date-meridiem" style="font-size:1rem">${meridiem}</span></span></span>`;
            }
            return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:1rem">${fullTime}</span></span></span>`;
          }
          return d ? new Date(d).getTime() : 0;
        }
      },
      {
        title: "Description",
        data: "description",
        className: "wrap-text",
        render: (data, type, row, meta) => showDescription(data, row),
        responsivePriority: 3
      },
      {
        title: "Amount",
        data: "amount",
        render: (d, type, row) => {
          if (Number(row?.voided) === 1) {
            return `<span class="ledger-row-voided" style="font-size:1rem">${formatTruncate(
              d
            )}</span>`;
          }
          return `<span style="font-size:1rem">${formatTruncate(d)}</span>`;
        },
        responsivePriority: 4
      },

      {
        title: "Balance",
        data: "after_balance",
        render: (d, type, row) => {
          if (Number(row?.voided) === 1) {
            return `<span class="ledger-row-voided" style="font-size:1rem">${formatTruncate(
              d
            )}</span>`;
          }
          return `<span style="font-size:1rem">${formatTruncate(d)}</span>`;
        },
        responsivePriority: 5
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "",
        data: "type",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "game_type",
        data: "game_type",
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 7,
        visible: false
      },
      {
        title: "market_type",
        data: "market_type",
        render: (d) => `<span>${d}</span>`,
        visible: false,
        responsivePriority: 8
      }
    ],
    []
  );

  let username = "";
  let sponsor = "";
  /*if (userData !== "" && userData !== null && userData !== undefined) {
    username = userData.uname;
    sponsor = userData.sponsor;
  }*/

  const showCreditCashTxt = (payment_type) => {
    let returnTxt = "";
    if (payment_type == 1) {
      returnTxt = "(Credit)";
    } else if (payment_type == 2) {
      returnTxt = "(Cash)";
    }
    return returnTxt;
  };

  const openCreditDebitDetailsPopUp = async (id) => {
    const popup = window.open(
      "/credit-debit-popup-details/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const openLedgerPopUp = async (id, game_type) => {
    if (game_type == 9) {
      const popup = window.open(
        "/client-virtual-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else if (game_type == 6) {
      const popup = window.open(
        "/client-casino-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else if (game_type == 7 || game_type == 10) {
      const popup = window.open(
        "/client-tp-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else {
      const popup = window.open(
        "/clinet-bet-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    }
  };

  const openPopUp = async (id) => {
    const popup = window.open(
      "/plby-hierarchical/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  useEffect(() => {
    window.showBetDetails = (id, game_type, type, user_role) => {
      if (type == 3) {
        openCreditDebitDetailsPopUp(id);
      } else {
        if (user_role == 8) {
          openLedgerPopUp(id, game_type);
        } else {
          openPopUp(id);
        }
      }
    };

    return () => {
      // clean up when react component unmounts. It will clean it from the memory when we will navigate to other component or page.
      delete window.showBetDetails;
    };
  }, []);

  const startDateSet = (date) => {
    setStartDate(date);
  };

  const endDateSet = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    // Don't initialize DataTable while loading or if no data
    if (isLoading || !statement.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    // Clean up any existing DataTable properly
    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      // Remove all event listeners first
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      // Destroy the DataTable
      dt.destroy(true);
      $table.empty();
    }

    // Normalize column definitions (support data/title and legacy mData/sTitle)
    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    // Ensure first column (seq/#) is orderable
    if (normalizedCols[0]) {
      normalizedCols[0].orderable = true;
    }

    // Compute initial order from columns (supports col.order = "asc"|"desc")
    const initialOrder = [];
    normalizedCols.forEach((col, idx) => {
      if (
        col.order &&
        ["asc", "desc"].includes(String(col.order).toLowerCase())
      ) {
        initialOrder.push([idx, col.order]);
      }
    });

    // Build safe statement (only include referenced keys + seq + void metadata)
    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (statement || []).map((row, i) => {
      const out = { seq: i + 1 }; // seq is initial placeholder; will be updated after draw
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });
      if ("voided" in row) out.voided = row.voided;
      if ("result" in row) out.result = row.result;
      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        columns: normalizedCols,
        responsive: { details: false },
        pageLength: pageSize || 10,
        lengthChange: false,
        autoWidth: false,
        ordering: true,
        orderSequence: ["asc", "desc"],
        order: initialOrder.length ? initialOrder : [[0, "asc"]],
        columnDefs: [
          {
            targets: 0,
            orderable: true,
            width: "9%",
            className: "dt-center",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 1,
            width: "32.8%",
            className: "dt-right",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 2,
            width: "20%",
            className: "dt-left",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 3,
            width: "17.1%",
            className: "min-desktop",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 4,
            width: "17.1%",
            className: "min-desktop",
            orderSequence: ["asc", "desc"]
          }
        ],
        //dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> <"dt-buttons"> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',

        dom: '<"dt-search"f>' + "rt" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",

        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
      return;
    }

    // Helper: find hidden columns for a row (used for child details)
    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden"))
            hiddenCols.push(i);
        });
      return hiddenCols;
    };

    //mobile view
    // Build hidden row details (same as your previous implementation)

    const buildHiddenDetails = (rowData, tr) => {
      const settings = dt.settings()[0];
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return "";
      let html = "";

      hiddenCols.forEach((i) => {
        const col = dt.column(i);
        if (!col || !col.header()) return;

        const title = ($(col.header()).text() || "").trim();
        if (!title) return;

        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];

        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        const safeTitle = title
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");

        html += `
      <tr>
        <td class="ledger-detail-cell">
          <div class="ledger-detail-line">
            <span class="ledger-detail-label">${safeTitle}:</span>
            <div class="ledger-detail-value">${rendered}</div>
          </div>
        </td>
      </tr>`;
      });
      return html;
    };

    // Update toggle button / child rows as before
    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;
        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0 ledger-child-table">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0 ledger-child-table">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return;
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(
            `<table class="table table-sm mb-0 ledger-child-table">${details}</table>`
          )
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    // Update toggle buttons after draw/order/search
    dt.on("order.dt search.dt draw.dt", () => {
      try {
        updateToggleButtons();
      } catch (e) {
        console.warn("Toggle update failed:", e);
      }
    });

    requestAnimationFrame(() => {
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__dt_safe_timer);
      window.__dt_safe_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__dt_safe_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during DataTable cleanup:", error);
        }
      }
    };
  }, [cols, statement, pageSize, defaultExpand, isLoading]);

  const getHistory = useCallback(async () => {
    // Prevent multiple simultaneous requests
    console.log("Trying to fetch account statement");
    dispatch(setLoader(true));
    if (loadingRef.current) return;

    let from = toLocalString(startDate);
    let til = toLocalString(endDate);

    //setIsLoading(true);
    loadingRef.current = true;

    let cdType = type;
    let payment_type = 2;
    if (cdType == "crle") {
      payment_type = 1;
    }

    /*let obj = {};
    obj.userId = userId;
    obj.startDate = from;
    obj.endDate = til;
    obj.endDate = til;
    obj.payment_type = payment_type;*/

    let obj = {};
    obj.userId = userId;
    obj.startDate = from;
    obj.endDate = til;

    try {
      const response = await axiosInstance.post("/company/pl-Downline", obj);
      setTimeout(() => {
        setStatement(response.data.recordList || []);

        setUniqueGridKey(Date.now());
        setIsLoading(false);
        dispatch(setLoader(false));

        setDataUserName(response?.data?.username);
        loadingRef.current = false;
      }, 100);
      console.log("Account Statement Response:", response.data);

      // Small delay to ensure proper cleanup of previous DataTable
    } catch (error) {
      console.error("Error fetching account statement:", error);
      await dispatch(setLoader(false));
      setIsLoading(false);
      loadingRef.current = false;
      setStatement([]);
    }
  }, [startDate, endDate]);

  function toLocalString(d) {
    const pad = (x) => String(x).padStart(2, "0");
    return (
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    );
  }
  useEffect(() => {
    getHistory();
  }, []);

  return (
    <div className="container-fluid" style={{ padding: "0px 5px 0px 5px" }}>
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <i className="fa fa-align-justify"></i> Report Filter
              </div>
              <div className="card-body">
                <form
                  id="ReportFilterForm"
                  className="form-inline"
                  method="get"
                  style={{ padding: "7px" }}
                >
                  <div className="row" style={{ textAlignLast: "justify" }}>
                    <div className="col-12 col-md-5">
                      {/*<DatePickerComponent
                        defaultDate={startDate}
                        setSelectedDate={startDateSet}
  />*/}

                      <Bootstrap4DatePickerComponent
                        pickerId="ReportFrom"
                        inputId="DisplayFrom"
                        defaultDate={startDate}
                        setSelectedDate={startDateSet}
                      />
                    </div>
                    <strong style={{ margin: "auto" }}>&nbsp;-&nbsp;</strong>
                    <div className="col-12 col-md-5">
                      {/*<DatePickerComponent
                            defaultDate={endDate}
                            setSelectedDate={endDateSet}
                          />*/}

                      <Bootstrap4DatePickerComponent
                        pickerId="ReportTo"
                        inputId="DisplayTo"
                        defaultDate={endDate}
                        setSelectedDate={endDateSet}
                      />
                    </div>
                    <div
                      className="editsbmtbtn"
                      style={{
                        marginTop: "10px",
                        marginRight: "11px",
                        width: isMobile ? "100%" : "auto"
                      }}
                    >
                      <button
                        style={{ float: "right", background: "#02b181" }}
                        className="btn btn-success"
                        onClick={() => getHistory()}
                        type="button"
                      >
                        <strong className="site_family">Submit</strong>
                      </button>
                    </div>
                  </div>
                  <div className="row col-12"></div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header site_family">
                <strong id="display_uname" className="site_family">
                  {dataUserName}
                </strong>{" "}
                - Account Ledger
              </div>
              <div className="card-body">
                <div
                  id="tableLedger_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="dataTables_wrapper no-footer">
                        <div className="row">
                          <div className="col-sm-12">
                            <div>
                              {isLoading ? (
                                <div className="text-center mt-4 mb-4">
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  >
                                    <span className="sr-only site_family">
                                      Loading...
                                    </span>
                                  </div>
                                  <p className="text-muted mt-2 site_family">
                                    Loading account statement...
                                  </p>
                                </div>
                              ) : statement.length === 0 ? (
                                <p className="text-center mt-3 text-muted site_family">
                                  No records found for the selected period.
                                </p>
                              ) : (
                                <div
                                  className="table-responsive p-1"
                                  key={uniqueGridKey}
                                >
                                  <table
                                    ref={gridTableRef}
                                    className="table table-striped table-bordered dataTable no-footer dtr-inline display mt-2"
                                    style={{ width: "100%" }}
                                  >
                                    <thead>
                                      <tr>
                                        {cols.map((c) => (
                                          <th key={c.data || c.title}>
                                            {c.title}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody />
                                  </table>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
      .rdt_Pagination {
        justify-content: flex-start; /* left */
        /* center */
        justify-content: center;
        /* right */
        justify-content: flex-end;
      }
  .table { width: 100% !important; }
  #tableLedger_wrapper .table-responsive {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .table.table-striped td, .table.table-striped th {
    padding: 6px 8px !important;
    font-size:17px;
    white-space: nowrap;
    vertical-align: middle;
  }
  table.table-sm td { padding: 4px 6px !important; }
  #tableLedger_wrapper tr.shown + tr > td {
    background-color: #ffffff !important;
  }
  .seq-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    margin: 0 auto;
  }
  .seq-cell .seq-number { flex: 0 0 auto; }
  /* --- Date cell: desktop = single line, tablet = two lines, mobile = current --- */
  .date-cell-wrap {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.3em;
    width: 100%;
    text-align: right;
    line-height: 1.3;
    white-space: nowrap;
  }
  .date-part { flex: 0 0 auto; }
  .date-time-block {
    flex: 0 0 auto;
    white-space: nowrap;
  }
  .date-time, .date-meridiem { display: inline; }

  /* Tablet (641px – 1024px): date on line 1, time+meridiem on line 2 */
  @media screen and (min-width: 641px) and (max-width: 1024px) {
    .date-cell-wrap {
      flex-direction: column;
      align-items: flex-end;
      gap: 0;
      white-space: normal;
    }
    .date-part { display: block; width: 100%; text-align: right; }
    .date-time-block { display: block; width: 100%; text-align: right; }
  }

  /* Mobile (≤640px): each piece on its own line */
  @media screen and (max-width: 640px) {
    .date-cell-wrap {
      flex-direction: column;
      align-items: flex-end;
      gap: 0;
      white-space: normal;
    }
    .date-part { display: block; width: 100%; text-align: right; }
    .date-time-block { display: block; width: 100%; text-align: right; }
    .date-time  { display: block; width: 100%; text-align: right; }
    .date-meridiem { display: block; width: 100%; text-align: right; }
  }

  /* DataTables 2: force right-align on Date column (th + td) */
  #tableLedger_wrapper table.dataTable thead th:nth-child(2),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(2),
  #tableLedger_wrapper table.dataTable th.dt-right,
  #tableLedger_wrapper table.dataTable td.dt-right {
    text-align: right !important;
    vertical-align: middle !important;
  }
  /* DataTables 2 wraps header title in a flex row; push title to the right */
  #tableLedger_wrapper table.dataTable thead th:nth-child(2) div.dt-column-header,
  #tableLedger_wrapper table.dataTable th.dt-right div.dt-column-header {
    justify-content: flex-end !important;
    flex-direction: row-reverse !important;
  }
  #tableLedger_wrapper table.dataTable thead th div.dt-column-header {
    flex-direction: row !important;
  }
  /* Override the generic rule above only for col 2 */
  #tableLedger_wrapper table.dataTable thead th:nth-child(2) div.dt-column-header {
    flex-direction: row-reverse !important;
  }
  .toggle-row {
    border: none;
    outline: none;
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    line-height: 1;
    box-shadow: none;
    -webkit-tap-highlight-color: transparent;
  }
  .toggle-row:focus,
  .toggle-row:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }
  .toggle-closed { background-color: #28a745; }
  .toggle-open { background-color: #dc3545; }
  .toggle-row:active { transform: scale(0.94); }

  /* Hide DataTables responsive default +/- control; we use .toggle-row instead */
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before,
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before,
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
    display: none !important;
    content: none !important;
  }
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child,
  #tableLedger_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child {
    padding-left: 8px !important;
    padding-right: 8px !important;
    cursor: default;
  }
  .dt-info { float:none; text-align:left; }
  .dt-paging-button { margin-left:0 !important; padding: 0 !important; }
  .dt-paging { text-align:center !important;float:right }
  .pagination { display:block !important; }

  /* Print preview table (same page): plain white rows — avoids removed global transparent hacks */
  .account-statement-print-table tbody tr,
  .account-statement-print-table tbody td {
    background-color: #ffffff !important;
  }

  .toggle-row { width:15px; height:15px; margin-left:2px; }

  /* Ledger: all data rows #FFFFFF (overrides Bootstrap / DataTables cell backgrounds) */
  #tableLedger_wrapper table.dataTable tbody > tr:not(.child),
  #tableLedger_wrapper table.dataTable tbody > tr:not(.child) > td {
    background-color: #ffffff !important;
  }

  /* Ledger: narrower Date, wider Description */
  #tableLedger_wrapper .table-responsive > table.dataTable {
    table-layout: fixed;
    width: 100% !important;
  }
  #tableLedger_wrapper table.dataTable thead th:nth-child(2),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(2) {
    box-sizing: border-box;
    white-space: nowrap;
  }



  /* vvvv Amount & Balance: right-aligned to match screenshot */
  #tableLedger_wrapper table.dataTable thead th:nth-child(4),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(4),
  #tableLedger_wrapper table.dataTable thead th:nth-child(5),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(5) {
    text-align: right !important;
    white-space: nowrap;
  }
  #tableLedger_wrapper table.dataTable thead th:nth-child(3),
  #tableLedger_wrapper table.dataTable tbody td:nth-child(3) {
    min-width: 0;
    box-sizing: border-box;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    vertical-align: middle !important;
  }
  #tableLedger_wrapper table.dataTable tbody td:nth-child(3) a {
    white-space: normal !important;
    word-break: break-word;
  }

  #tableLedger_wrapper table.ledger-child-table {
    width: 50% !important;
    table-layout: fixed;
    margin: 0 !important;
  }
  #tableLedger_wrapper td.ledger-detail-cell {
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-bottom: 0px solid #eee !important;
    //padding: 1px 1px !important;
    padding: 8px 10px !important;
    vertical-align: middle !important;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    text-align: left;
  }
  /* Mobile detail rows: "Heading: value" on one line (wraps when long) */
  #tableLedger_wrapper .ledger-detail-line {
    display: flex;
    border-bottom: 1px solid #eee !important;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: flex-start;
    gap: 0 0.35rem;
    line-height: 1.4;
  }
  #tableLedger_wrapper .ledger-detail-label {
    font-weight: 700 !important;
    color: #000 !important;
    font-size: 0.95rem !important;
    flex: 0 0 auto;
    border-bottom: 0px solid #eee !important;
    margin-bottom: 0 !important;
  }
  #tableLedger_wrapper .ledger-detail-value {
    font-size: 0.95rem;
    color: #212529;
    flex: 1 1 auto;
    min-width: 0;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  #tableLedger_wrapper .ledger-detail-value span { 
   border-bottom: 0px solid #eee !important;
  } 
  #tableLedger_wrapper .ledger-detail-value a {
    white-space: normal !important;
    word-break: break-word;
  }

  .dt-search { float:right; padding-right:10px; }
  .dt-search .form-control{
    border: 1px solid #ced4da;
    margin-bottom:5px;
    background-color: #ffffff;
    color: #212529;
  }

  .ledger-row-voided,
  .ledger-row-voided:hover {
    text-decoration: line-through !important;
    opacity: 0.65;
    color: #6c757d !important;
  }

  .actionBtn {
    position: absolute;
    width: 100%;
    margin-top: 0px;
    z-index: 12;
    margin-left: 1px;
    /* Let clicks reach DT search where this row has no controls */
    pointer-events: none;
  }
  .actionBtn select,
  .actionBtn button,
  .actionBtn label,
  .actionBtn .dt-buttons,
  .actionBtn .dataTables_length {
    pointer-events: auto;
  }

  /* Keep DT search above the action row and clickable */
  #tableLedger_wrapper .dt-search,
  #tableLedger_wrapper .dataTables_filter {
    position: relative;
    z-index: 11;
    pointer-events: auto;
  }

  /* Report filter — match legacy BPEXCH Account Ledger */
  #ReportFilterForm .datee,
  #ReportFilterForm .datetimepicker-input {
    background-color: #ffffff !important;
    color: #212529;
    font-size: 1rem;
  }
  #ReportFilterForm .input-group.date {
    width: 100%;
    flex-wrap: nowrap;
  }
  #ReportFilterForm .input-group .form-control {
    border: 1px solid #ced4da;
    border-right: 0;
    border-radius: 0.25rem 0 0 0.25rem;
    height: calc(1.5em + 0.75rem + 2px);
  }
  #ReportFilterForm .input-group-append .input-group-text {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-left: 0;
    border-radius: 0 0.25rem 0.25rem 0;
    cursor: pointer;
    color: #495057;
  }
  #ReportFilterForm .input-group-append .input-group-text:hover {
    background-color: #dde2e6;
  }
  #ReportFilterForm .bootstrap-datetimepicker-widget {
    z-index: 1050 !important;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  #ReportFilterForm .bootstrap-datetimepicker-widget table td.active,
  #ReportFilterForm .bootstrap-datetimepicker-widget table td.active:hover,
  #ReportFilterForm .bootstrap-datetimepicker-widget table td span.active {
    background-color: #00b181 !important;
    color: #fff !important;
  }
  #ReportFilterForm .bootstrap-datetimepicker-widget table td.today:before {
    border-bottom-color: #00b181;
  }
  #ReportFilterForm .bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
    background: #e9ecef;
  }
  @media screen and (max-width: 635px) {
    #ReportFilterForm .editsbmtbtn {
      margin: auto;
      margin-right: 15px;
    }
  }

  /* MOBILE ONLY FIXES */
  @media screen and (max-width: 640px) {

    .dt-info { float:none; text-align:center; }

    .table-wrap,
    #pldetail {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }

    #tableLedger_wrapper .table-responsive > table.dataTable {
      width: 90% !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    #tableLedger_wrapper table.dataTable thead th:nth-child(1),
    #tableLedger_wrapper table.dataTable tbody td:nth-child(1) {
      width: 12% !important;
    }

    #tableLedger_wrapper table.dataTable thead th:nth-child(2),
    #tableLedger_wrapper table.dataTable tbody td:nth-child(2) {
      width: 8.98% !important;
      min-width: 0 !important;
      max-width: none !important;
    }

    #tableLedger_wrapper td.ledger-detail-cell {
      //padding-left: calc(12% + 8.98%) !important;
      padding-left: 0px;
    }

    .dt-paging { 
      float:unset;
    }

    #tableLedger_wrapper table.dataTable thead th:nth-child(3),
    #tableLedger_wrapper table.dataTable tbody td:nth-child(3) {
      width: 79.02% !important;
      min-width: 0 !important;
    }

    #ReportFilterForm .form-group {
      width: 100% !important;
      margin-bottom: 0;
    }
    #ReportFilterForm .input-group {
      width: 100% !important;
      max-width: 100% !important;
    }
    #ReportFilterForm .input-group .form-control {
      flex: 1 1 auto;
      min-width: 0;
      width: 1%;
    }

    #ReportFilterForm .editsbmtbtn {
      width: 100% !important;
      display: flex !important;
      justify-content: flex-end !important;
      align-items: center !important;
      margin-top: 0.5rem;
    }
    #ReportFilterForm .editsbmtbtn .btn {
      margin-right: 20px;
    }

    .actionBtn {
      width: 100%;
      margin-top: 0px;
      position: relative;
    }

    .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }

    .dataTable {
      margin-top:10px !important;
    }

    .table-responsive {
      margin-top:0px !important;
    }

    .dt-buttons {
      margin: 0 auto !important;
      float: none !important;
      width: auto !important;
      display: flex !important;
      justify-content: center;
    }
      
  }
        .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }
      @media screen and (max-width: 640px) {
  /* Make the top area stack nicely */
  .top.d-flex {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  /* Center the search container */
  .dt-search {
    display: flex !important;
    justify-content: center !important; /* center horizontally */
    width: 100% !important;
    margin: 8px 0 !important;
    padding: 0 12px;
    box-sizing: border-box;
  }

  /* Ensure the label + input stay inline and centered */
  .dt-search .dataTables_filter,
  .dataTables_filter {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    justify-content: center;
    width: auto !important;
    margin: 0;
  }

  /* Limit input width so it doesn't push other controls */
  .dt-search input[type="search"],
  .dataTables_filter input[type="search"] {
    width: 160px !important;
    max-width: 80% !important;
    display: inline-block !important;
    margin: 0 !important;
    border: 1px solid #ced4da !important;
    background-color: #ffffff !important;
    color: #212529 !important;
  }
    .dt-container {
      margin-top:0px !important;
    }
    }
    .dataTable {
    margin-top:15px;
    }

    table.dataTable.hover > tbody > tr:hover > *, table.dataTable.display > tbody > tr:hover > * {
      /* box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.035); */
      /* box-shadow: inset 0 0 0 9999px rgba(var(--dt-row-hover), var(--dt-row-hover-alpha)); */
  }
    
`}</style>
    </div>
  );
}
